export enum UserSessionInputs {
    BrowseResourceSearch = 'BrowseResourceSearch',
    BrowseResourceFilterType = 'BrowseResourceFilterType',

    BrowseProcedureSearch = 'BrowseProcedureSearch',
    BrowseProcedureFilterType = 'BrowseProcedureFilterType',

    BrowseAssetSearch = 'BrowseAssetSearch',

    BrowsePurchaseRequestListsSearch = 'BrowsePurchaseRequestListsSearch',
    BrowsePurchaseRequestListsFilter = 'BrowsePurchaseRequestListsFilter',

    BrowseContactsSearch = 'BrowseContactsSearch',

    BrowseProductSearch = 'BrowseProductSearch',
    BrowseProductFilterType = "BrowseProductFilterType",
    BrowseProductIncompleteProductFilter = "BrowseProductIncompleteProductFilter",

    BrowseMaterialSearch = 'BrowseMaterialSearch',

    BrowsePlasticsHardwareItemSearch = 'BrowsePlasticsHardwareItemSearch',
    BrowsePlasticsHardwareItemFilterType = 'BrowsePlasticsHardwareItemFilterType',

    BrowseCustomerSearch = 'BrowseCustomerSearch',
    BrowseCustomerFilter = 'BrowseCustomerFilter',

    BrowseVendorSearch = 'BrowseVendorSearch',
    BrowseVendorFilter = 'BrowseVendorFilter',

    BrowseFixtureSearch = 'BrowseFixtureSearch',

    PlasticsProductionReportsDateRange = "PlasticsProductionReportsDateRange",
    PlasticsMoldReportsDateRange = "PlasticsMoldReportsDateRange",
    PlasticsMaterialReportsDateRange = "PlasticsMaterialReportsDateRange",

    PlasticsScrapReportsDateRange = "PlasticsScrapReportsDateRange",

    BrowsePlasticsOrdersSearch = 'BrowsePlasticsOrdersSearch',

    BrowseWorkOrderSearch = 'BrowseWorkOrderSearch',
    BrowseWorkOrderFilterType = 'BrowseWorkOrderFilterType',

    BrowseMetalsHardwareItemSearch = 'BrowseMetalsHardwareItemSearch',
    BrowseMetalsHardwareItemFilterType = 'BrowseMetalsHardwareItemFilterType',

    MetalsLaserFilterType = 'MetalsLaserFilterType',

    BrowseFactoryNodeSearch = 'BrowseFactoryNodeSearch',

    BrowseRobotProgramSearch = 'BrowseRobotProgramSearch',

    BrowseClientDeviceSearch = 'BrowseClientDeviceSearch',

    BrowseEngineeringUpdateMeetingSearch = 'BrowseEngineeringUpdateMeetingSearch',
    BrowseEngineeringUpdateMeetingFilter = 'BrowseEngineeringUpdateMeetingFilter',

    BrowseC3HardwareItemsSearch = 'BrowseC3HardwareItemsSearch',
    BrowseC3HardwareItemsFilter = 'BrowseC3HardwareItemsFilter',
    BrowseC3HardwareItemsModelVehicles = 'BrowseC3HardwareItemsModelVehicles',
    BrowseC3HardwareItemsBodyLidMode = 'BrowseC3HardwareItemsBodyLidMode',
    BrowseC3HardwareItemsColorCodes = 'BrowseC3HardwareItemsColorCodes',
    BrowseC3HardwareItemsVendors = 'BrowseC3HardwareItemsVendors',
    BrowseC3HardwareItemsStockStates = 'BrowseC3HardwareItemsStockStates',
    BrowseC3HardwareItemsRiderOnly = 'BrowseC3HardwareItemsRiderOnly',

    BrowseC3ProductsSearch = 'BrowseC3ProductsSearch',
    BrowseC3ProductsFilter = 'BrowseC3ProductsFilter',
    BrowseC3ProductsModelVehicles = 'BrowseC3ProductsModelVehicles',
    BrowseC3ProductsBodyLidMode = 'BrowseC3ProductsBodyLidMode',
    BrowseC3ProductsColorCodes = 'BrowseC3ProductsColorCodes',
    BrowseC3ProductsStockStates = 'BrowseC3ProductsStockStates',
    BrowseC3ProductsRiderOnly = 'BrowseC3ProductsRiderOnly',

    BrowseC3OrdersSearch = 'BrowseC3OrdersSearch',
    BrowseInjectionMoldingOrdersSearch = 'BrowseInjectionMoldingOrdersSearch',

    BrowseMetalsProjectSearch = 'BrowseMetalsProjectSearch',
    BrowseMetalsProjectUserFilter = 'BrowseMetalsUserFilter',
    BrowseMetalsProjectScrollPosition = 'BrowseMetalsProjectScrollPosition',
    BrowseMetalsProjectFilterType = 'BrowseMetalsProjectFilterType',
    BrowseMetalsProjectHidePowderCoatingOnlyIncomplete = 'BrowseMetalsProjectHidePowderCoatingOnlyIncomplete',
    BrowseMetalsOrdersSearch = 'BrowseMetalsOrdersSearch',

    BrowseCameraSearch = 'BrowseCameraSearch',

}
